<template>
  <div class="upload">
    <div style="width:100%">
      <div v-if="imgList.length === num" style="position: relative; width: 100%;display:flex;flex-wrap: wrap;justify-content: flex-start;">
        <div
          v-for="(value,key) in imgList"
          v-if="type==='img'"
          style="position:relative;
          width: 146px;height: 146px;
          overflow: hidden; 
          box-shadow:1px 1px 4px rgba(0,0,0,0.1);
          border-radius: 10px; 
          margin-bottom:10px;margin-right:10px;
          box-sizing: border-box;"
          class="upload-image"
          
        >
          <el-image
            style="width: 100%;height: 100%"
            class="el-upload-list__item-thumbnail"
            fit="contain"
            :src="value.url"
            alt
          ></el-image>
          <div class="upload-tooltips" style="width:146px;height:146px;">
            <i
              class="el-icon-zoom-in"
              style="color:white;font-size: 20px;"
              @click="handlePictureCardPreview(value)"
            ></i>
            <i
              class="el-icon-delete"
              style="color:white;margin-left:10px;font-size: 20px;"
              @click="handleRemove(key)"
            ></i>
          </div>
        </div> 
        <div style="width:100%;" v-if="type==='video'">
          <video style="width:100%" :src="imgList[0].url" class="video" controls="controls"></video>
          <el-button @click="removeVideo">删除视频</el-button>
        </div>
      </div>
    </div>
    <el-upload
      v-if="imgList.length !== num"
      :action="actionPath"
      list-type="picture-card"
      :data="postData"
      :multiple="multiple"
      :on-remove="handleRemove"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      :on-preview="handlePictureCardPreview"
      :on-progress="progressUpload"
      :limit="num"
      :file-list="imgList"
      accept=".jpeg, .jpg, .gif, .png, .mp4"
      ref="uploadImage"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="previewImage" alt/>
    </el-dialog>
  </div>
</template>

<script>
    import {getQiniuToken} from "@/api/public";
    import qiniuUploader from "@/util/qiniuUploader.js";

    export default {
        props: {
            multiple: {
                type: Boolean,
                default: false
            },
            num: {
                type: Number,
                default: 1
            },
            path: {
                type: String,
                default: ""
            },
            images: {
                type: [String, Array],
                default: ""
            }
        },
        data() {
            return {
                domain: "https://cdn.cxc-group.com/",
                actionPath: "https://up-z0.qiniup.com",
                dialogVisible: false,
                disabled: false,
                showBtnImg: true,
                noneBtnImg: false,
                previewImage: '',
                type: '',
                postData: {
                    token: "",
                    key: this.path
                },
                uploadAddr: "https://cdn.cxc-group.com/",
                imageUrl: "",
                imgList: [],
                isUpdated: false
            };
        },
        mounted() {
            getQiniuToken().then((res) => {
                this.postData.token = res.data;
                qiniuUploader.init({
                    region: "CXC",
                    uptoken: "",
                    domain: 'cxc-group',
                    shouldUseQiniuFileName: true,
                    key: this.path + "/"
                });
            });
        },
        watch: {
            images: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    if (typeof newValue === 'string') {
                        if (newValue !== '') {
                            this.imgList = [{url: newValue, status: "success", percentage: 100}];
                            if (newValue.indexOf(".mp4") > -1) {
                                this.type = 'video';
                            } else {
                                this.type = 'img';
                            }
                        } else {
                            this.type = "img";
                            this.imgList = [];
                        }
                    } else {
                        this.imgList = [];
                        newValue.forEach((value, key) => {
                            this.imgList.push({
                                url: value,
                                status: "success",
                                percentage: 100
                            });
                        });
                    }
                }
            }
        },
        methods: {
            beforeAvatarUpload(file) {
                this.postData.key = this.path + "/" + this.createNonceStr() + "." + this.suffix(file.name);
            },
            success(imgList) {
                this.$emit('success', imgList);
            },
            sendRemove(imgList) {
                this.$emit('remove', imgList);
            },
            sendPreview(previewImage) {
                this.$emit('preview', previewImage);
            },
            progressUpload(event, file, fileList) {
                if (event.percent === 100) {
                    this.isUpdated = true;
                } else {
                    this.isUpdated = false;
                }
            },
            removeVideo() {
                this.imgList = [];
                this.imageUrl = '';
                this.type = 'img';
            },
            handleAvatarSuccess(res, file, fileList) {
                if (this.isUpdated) {
                    let images = [];
                    if (fileList.length === 1 && fileList[0].response.key.indexOf('.mp4') > -1) {
                        this.type = 'video';
                        images = [this.uploadAddr + fileList[0].response.key];
                        this.success(images);
                    } else {
                        this.type = 'img';
                        fileList.forEach((value, key) => {
                            if (value.status === "success" && value.percentage === 100) {
                                this.isUpdated = true;
                                if (value.response) {
                                    images.push(this.uploadAddr + value.response.key);
                                }
                                if (value.url.indexOf(this.uploadAddr) > -1) {
                                    images.push(value.url);
                                }
                            } else {
                                this.isUpdated = false;
                            }
                        });

                        if (this.num == images.length) {
                            this.showBtnImg = false;
                            this.noneBtnImg = true;
                        }
                        if (images.length < fileList.length) {
                            this.isUpdated = false;
                        } else {
                            this.success(images);
                        }
                    }
                }
            },
            handlePictureCardPreview(file) {
                this.previewImage = file.url;
                this.dialogVisible = true;
            },
            handleRemove(key) {
                let images = [];
                if (typeof key === 'number') {
                    // 数字索引删除逻辑
                } else {
                    this.imgList.forEach((value, k) => {
                        if (value.uid !== key.uid) {
                            images.push(value.url);
                        }
                    });
                }
                this.sendRemove(images);
            },
            suffix(filename) {
                var index = filename.lastIndexOf(".");
                var ext = filename.substr(index + 1);
                return ext;
            },
            createNonceStr() {
                let chars = [
                    "0", "1", "2", "3", "4", "5", "6", "7", "8", "9",
                    "A", "B", "C", "D", "E", "F", "G", "H", "I", "J",
                    "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T",
                    "U", "V", "W", "X", "Y", "Z",
                    "a", "b", "c", "d", "e", "f", "g", "h", "i", "j",
                    "k", "l", "m", "n", "o", "p", "q", "r", "s", "t",
                    "u", "v", "w", "x", "y", "z"
                ];
                let res = "";
                for (var i = 0; i < 16; i++) {
                    res += chars[Math.ceil(Math.random() * 35)];
                }
                return res;
            }
        }
    };
</script>

<style lang="scss">
  .upload {
    // width: 370px;
  }

  .uoloadSty {
    display: block;
  }

  .disUoloadSty {
    display: none;
  }

  .upload-tooltips {
    display: none;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 6px;
    color: white;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.5);
    justify-content: center;
    align-items: center;
  }

  .upload-image:hover {
    .upload-tooltips {
      display: inline-flex;
    }
  }
</style>
